import {
	CheckOutlined, EnvironmentOutlined, FileDoneOutlined,
	FileOutlined,
	FileSyncOutlined, FundOutlined, HomeOutlined,
	InboxOutlined,
	MinusSquareOutlined,
	PlusSquareOutlined,
	SettingOutlined, ShopOutlined, ShoppingCartOutlined, UnorderedListOutlined,
	UsergroupAddOutlined,
	UserOutlined,
	UserSwitchOutlined,
	FileTextOutlined,
	ShoppingOutlined
} from "@ant-design/icons";
import { Menu } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import SuperAdminSidenav from "../superAdmin/SuperAdminSidenav";
import styles from "./Sidenav.module.css";

const Test = ({ color, collapsed = false }) => {
  const { pathname } = useLocation();

  // Check if user is super admin
  const isSuperAdmin = localStorage.getItem("isSuperAdmin") === "true";

  const getSelectedKey = (path) => {
    if (path === "/" || path === "/dashboard") return "dashboard";

    // PRODUCT section
    if (path.startsWith("/product-category")) return "productCategory";
    if (path.startsWith("/book-publisher")) return "bookPublisher";
    if (path.startsWith("/product-currency")) return "productCurrency";
    if (path.startsWith("/discount-master")) return "discountMaster";
    if (path.startsWith("/product")) return "products";

    // PURCHASE section
    if (path.startsWith("/supplier")) return "suppliers";
    if (path.startsWith("/purchase-order")) return "purchaseOrders";
    if (path.startsWith("/purchaselist")) return "purchaseList";
    if (path.startsWith("/purchase")) return "newPurchase";

    // SALE section
    if (path.startsWith("/customer")) return "customers";
    if (path.startsWith("/sales-order")) return "salesOrders";
    if (path.startsWith("/salelist")) return "saleList";
    if (path.startsWith("/sale")) return "newSale";

    if (path.startsWith("/transaction/create")) return "newTransaction";
    if (path.startsWith("/transaction/") || path === "/transaction") return "transactionList";

    // REPORT section
    if (path.startsWith("/account/trial-balance")) return "trialBalance";
    if (path.startsWith("/account/balance-sheet")) return "balanceSheet";
    if (path.startsWith("/account/income")) return "incomeStatement";
    if (path.startsWith("/account/profit-and-loss")) return "profitAndLoss";
    if (path.startsWith("/account/party-wise-profit-loss")) return "partyWiseProfitLoss";
    if (path.startsWith("/account/party-statement")) return "partyStatement";
    if (path.startsWith("/account/customer-supplier-summary")) return "customerSupplierSummary";

    if (path === "/pos") return "pos";

    // SETTINGS section
    if (path.startsWith("/invoice-setting")) return "invoiceSetting";
    if (path.startsWith("/account")) return "accountList";
    if (path.startsWith("/location")) return "location";
    if (path.startsWith("/hr/staffs")) return "staffs";
    if (path.startsWith("/role")) return "roleAndPermissions";
    if (path.startsWith("/designation")) return "designation";

    return undefined;
  };

  const selectedKey = getSelectedKey(pathname);

  const parentKey = useMemo(() => {
    if (!selectedKey) return null;
    if (["products", "productCategory", "bookPublisher", "productCurrency", "discountMaster"].includes(selectedKey)) return "product";
    if (["suppliers", "newPurchase", "purchaseList", "purchaseOrders"].includes(selectedKey)) return "purchaseSection";
    if (["customers", "newSale", "saleList", "salesOrders"].includes(selectedKey)) return "saleSection";
    if (["newTransaction", "transactionList"].includes(selectedKey)) return "accountSection";
    if (
      ["trialBalance", "balanceSheet", "incomeStatement", "profitAndLoss", "partyWiseProfitLoss", "partyStatement", "customerSupplierSummary"].includes(selectedKey)
    )
      return "reportSection";
    if (["pos"].includes(selectedKey)) return null;
    if (["invoiceSetting", "accountList", "location", "staffs", "roleAndPermissions", "designation"].includes(selectedKey)) return "settings";
    return null;
  }, [selectedKey]);

  const [openKeys, setOpenKeys] = useState(parentKey ? [parentKey] : []);
  useEffect(() => {
    // Sync open state when route changes, but keep user's manual toggling working otherwise.
    setOpenKeys(parentKey ? [parentKey] : []);
  }, [parentKey]);

  const menuSelectedKeys = selectedKey ? [selectedKey] : [];
  const menu = [
    {
      label: (
        <NavLink to="/dashboard">
          <span>Dashboard</span>
        </NavLink>
      ),
      key: "dashboard",
      icon: <HomeOutlined />,
    },
    {
      label: "PRODUCT",
      key: "product",
      icon: <ShopOutlined />,
      children: [
        {
          label: (
            <NavLink to="/product">
              <span>Product Master</span>
            </NavLink>
          ),
          key: "products",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/product-category">
              <span>Product Category</span>
            </NavLink>
          ),
          key: "productCategory",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/book-publisher">
              <span>Publisher Master</span>
            </NavLink>
          ),
          key: "bookPublisher",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/product-currency">
              <span>Currency Master</span>
            </NavLink>
          ),
          key: "productCurrency",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/discount-master">
              <span>Discount Master</span>
            </NavLink>
          ),
          key: "discountMaster",
          icon: <UnorderedListOutlined />,
        },
      ],
    },
    {
      label: "PURCHASE",
      key: "purchaseSection",
      icon: <PlusSquareOutlined />,
      children: [
        {
          label: (
            <NavLink to="/supplier">
              <span>Suppliers</span>
            </NavLink>
          ),
          key: "suppliers",
          icon: <UserOutlined />,
        },
        {
          label: (
            <NavLink to="/purchase">
              <span>New Purchase</span>
            </NavLink>
          ),
          key: "newPurchase",
          icon: <CheckOutlined />,
        },
        {
          label: (
            <NavLink to="/purchaselist">
              <span>Purchase List</span>
            </NavLink>
          ),
          key: "purchaseList",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/purchase-order">
              <span>Purchase Orders</span>
            </NavLink>
          ),
          key: "purchaseOrders",
          icon: <FileTextOutlined />,
        },
       
      ],
    },
    {
      label: "SALE",
      key: "saleSection",
      icon: <MinusSquareOutlined />,
      children: [
        {
          label: (
            <NavLink to="/customer">
              <span>Customers</span>
            </NavLink>
          ),
          key: "customers",
          icon: <UserOutlined />,
        },
        {
          label: (
            <NavLink to="/sale">
              <span>New Sale</span>
            </NavLink>
          ),
          key: "newSale",
          icon: <CheckOutlined />,
        },
        {
          label: (
            <NavLink to="/salelist">
              <span>Sale List</span>
            </NavLink>
          ),
          key: "saleList",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/sales-order">
              <span>Sales Orders</span>
            </NavLink>
          ),
          key: "salesOrders",
          icon: <ShoppingOutlined />,
        },
     
      ],
    },
    {
      label: "ACCOUNTS",
      key: "accountSection",
      icon: <InboxOutlined />,
      children: [
        
        {
          label: (
            <NavLink to="/transaction/create">
              <span>New Transaction</span>
            </NavLink>
          ),
          key: "newTransaction",
          icon: <CheckOutlined />,
        },
        {
          label: (
            <NavLink to="/transaction/">
              <span>Transaction List</span>
            </NavLink>
          ),
          key: "transactionList",
          icon: <UnorderedListOutlined />,
        },
      ],
    },
    {
      label: "REPORT",
      key: "reportSection",
      icon: <FundOutlined />,
      children: [
        {
          label: (
            <NavLink to="/account/trial-balance">
              <span>Trial Balance</span>
            </NavLink>
          ),
          key: "trialBalance",
          icon: <FileDoneOutlined />,
        },
        {
          label: (
            <NavLink to="/account/balance-sheet">
              <span>Balance Sheet</span>
            </NavLink>
          ),
          key: "balanceSheet",
          icon: <FileOutlined />,
        },
        {
          label: (
            <NavLink to="/account/income">
              <span>Income Statement</span>
            </NavLink>
          ),
          key: "incomeStatement",
          icon: <FileSyncOutlined />,
        },
        {
          label: (
            <NavLink to="/account/profit-and-loss">
              <span>P&L Report</span>
            </NavLink>
          ),
          key: "profitAndLoss",
          icon: <FileSyncOutlined />,
        },
        {
          label: (
            <NavLink to="/account/party-wise-profit-loss">
              <span>Party-wise P&L</span>
            </NavLink>
          ),
          key: "partyWiseProfitLoss",
          icon: <FileSyncOutlined />,
        },
        {
          label: (
            <NavLink to="/account/party-statement">
              <span>Party Statement</span>
            </NavLink>
          ),
          key: "partyStatement",
          icon: <FileTextOutlined />,
        },
        {
          label: (
            <NavLink to="/account/customer-supplier-summary">
              <span>Customer & Supplier Summary</span>
            </NavLink>
          ),
          key: "customerSupplierSummary",
          icon: <FileTextOutlined />,
        },
      ],
    },

   
    // {
    //   label: (
    //     <NavLink to="/pos">
    //       <span>POS</span>
    //     </NavLink>
    //   ),
    //   key: "pos",
    //   icon: <ShoppingCartOutlined />,
    // },

    {
      label: "SETTINGS",
      key: "settings",
      icon: <SettingOutlined />,
      children: [
        {
          label: (
            <NavLink to="/invoice-setting">
              <span>Invoice Settings</span>
            </NavLink>
          ),
          key: "invoiceSetting",
          icon: <SettingOutlined />,
        },
        {
          label: (
            <NavLink to="/account/">
              <span>Account</span>
            </NavLink>
          ),
          key: "accountList",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/location">
              <span>Location</span>
            </NavLink>
          ),
          key: "location",
          icon: <EnvironmentOutlined />,
        },
        {
          label: (
            <NavLink to="/hr/staffs">
              <span>User</span>
            </NavLink>
          ),
          key: "staffs",
          icon: <UsergroupAddOutlined />,
        },
        {
          label: (
            <NavLink to="/role">
              <span>Role & Permissions</span>
            </NavLink>
          ),
          key: "roleAndPermissions",
          icon: <UserSwitchOutlined />,
        },
        {
          label: (
            <NavLink to="/designation/">
              <span>Designation</span>
            </NavLink>
          ),
          key: "designation",
          icon: <UserSwitchOutlined />,
        },
      ],
    },
  ];

  return isSuperAdmin ? (
    <SuperAdminSidenav color={color} collapsed={collapsed} />
  ) : (
    <div className={styles.sidenavWrap}>
      <div className={styles.brandArea} aria-label="Project Header">
        <div className={styles.brandName}>
          <span className={styles.erpWhite}>ER</span>
          <span className={styles.erpCyan}>P</span>
        </div>
      </div>

      <Menu
        theme="dark"
        mode="inline"
        inlineCollapsed={collapsed}
        items={menu}
        className={styles.sidenavMenu}
        selectedKeys={menuSelectedKeys}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
      />
    </div>
  );
};

export default Test;
